"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newCatalogMeasure = exports.CatalogMeasureBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var groupFactory_1 = require("./groupFactory");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var builder_1 = require("../builder");
var measureFactory_1 = require("../metadata/measureFactory");
/**
 * Catalog measure builder
 * See {@link Builder}
 *
 * @beta
 */
var CatalogMeasureBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(CatalogMeasureBuilder, _super);
    function CatalogMeasureBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogMeasureBuilder.prototype.measure = function (measureOrRef, modifications) {
        if (!sdk_backend_spi_1.isMeasureMetadataObject(measureOrRef)) {
            this.item.measure = measureFactory_1.newMeasureMetadataObject(measureOrRef, modifications);
        }
        else {
            this.item.measure = measureOrRef;
        }
        return this;
    };
    CatalogMeasureBuilder.prototype.toExecutionModel = function (modifications) {
        var _this = this;
        if (modifications === void 0) { modifications = identity_1.default; }
        if (!this.item.measure) {
            throw new Error("Cannot convert catalog measure to execution model, no measure found!");
        }
        var defaultModifications = function (m) { var _a, _b; return m.alias((_a = _this.item.measure) === null || _a === void 0 ? void 0 : _a.title).format((_b = _this.item.measure) === null || _b === void 0 ? void 0 : _b.format); };
        return sdk_model_1.newMeasure(this.item.measure.ref, function (m) { return modifications(defaultModifications(m)); });
    };
    return CatalogMeasureBuilder;
}(groupFactory_1.GroupableCatalogItemBuilder));
exports.CatalogMeasureBuilder = CatalogMeasureBuilder;
/**
 * Catalog measure factory
 *
 * @param modifications - catalog measure builder modifications to perform
 * @returns created catalog measure
 * @beta
 */
exports.newCatalogMeasure = function (modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(CatalogMeasureBuilder, { type: "measure" }, modifications);
};
//# sourceMappingURL=measureFactory.js.map